import location from './modules/location'
import agency from './modules/agency'

export default {
  namespaced: true,
  modules: {
    location,
    agency,
  },
}
